import _axios from "../../../httpService"
import {prefixUrl} from "../../../utils/utilsData";
import SelectProductStoreRoom from "../../Factor/SelectProductStoreRoom";
import square from "../../../Assets/svg/add-square 1.svg";
import React, {useEffect, useState} from "react";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {myDataToWorkWithinComponent, resDataFromBack} from "./addProductSectionDataSadanShop";
import {
  addProductHandlerSadanShop,
  barcodeInputChangeHandler,
  changeNameHandler,
  changePackageTypeHandler,
  generateAllProductList,
  generateBarcodeList
} from "./AddProductSectionSadanFunctions";
import Select from "react-select";
import "./style.scss"


const AddProductSectionSadan = ({
                                  sendData,
                                  setSendData,
                                  initialData,
                                  componentData,
                                  setComponentData,
                                  isShowStoreRoom,
                                  mode,
                                  storeRoomType
                                }) => {

  const [isLoading, setIsLoading] = useState(true);
  const [myData, setMyData] = objectDataHolder(myDataToWorkWithinComponent);
  const [select, setSelect] = useState('barcode');


  useEffect(() => {

    let requestUrlByMode = "";
    let url = "";
    if (mode === "sell") {
      if (!componentData.currentStoreId) {
        //toast.error('تعیین انبار')
      }


      url = `/groceryStoreSellFactor/?request=productList&storeId=${componentData.currentStoreId}`
    }


    if (mode === 'remittance') {
      if (!componentData.currentStoreId) {
        return;
      }
      requestUrlByMode = "/storeRemittance"
      url = requestUrlByMode + "/?request=productList&listType=" + select + "&storeId=" + componentData.currentStoreId


      //url =  requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + searchTerm + "&option=" + selectedColorSize + "&storeId=" + componentData.currentStoreId

    }
    if (mode === 'buyReturn') {

      requestUrlByMode = "/returnFromBuy"
      // const returnFactorId = sendData.factorId
      // url = prefixUrl() + requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + "searchTerm" +
      //   "&option=" + "selectedColorSize" + "&storeId=" + componentData.currentStoreId + "&factorId=" + returnFactorId;


      // من اینجا چک کنم اگه فاکتور تایپ برابر با فاکتور بود باید  مقدار فاکتور آیدی از آرلوکاپ رو بزارم در غیراینصورت
      // باید خالی بزارم

      if (sendData.factorId === "" || sendData.factorId === undefined) {
        // toast.error("لطفا یک فاکتور انتخاب کنید.")
        return
      }
      const factorId = sendData.factorId;


      url = "/returnFromBuy/?request=productList&listType=" + select + "&factorId=" + factorId +
        "&storeId= " + componentData.currentStoreId;


    }

    if (mode === 'saleReturn') {
      if (!sendData.factorId) {
        return
      }
      url = "/returnFromSale/?request=productList&factorId=" + sendData.factorId

    }
    _axios.get(prefixUrl() + url).then(res => {
      //const data = resDataFromBack
      const data = res.data

      if (data.status) {

        const Object = {
          ...myData,
          bulkListName: data.data.bulk,
          packageListName: data.data.package,
        }

        Object.barcodeList = generateBarcodeList(Object.packageListName)
        Object.barcodeListToShow = generateBarcodeList(Object.packageListName)
        Object.allProductList = generateAllProductList(Object.bulkListName, Object.packageListName)
        setMyData(Object)
        setIsLoading(false)


        // setSearchListArray(data.data)
        // setIsLoading(false)


      }
    })

  }, [select, sendData.factorId, componentData.currentStoreId, sendData.sellerId]);
  const selectedStore = (id, text) => {
    setComponentData({currentStoreId: id, currentStoreName: text})
  }

  // console.log(":::myData:::")
  // console.log(myData)
  // console.log(":::myData:::")
  // console.log(":::sendData:::")
  // console.log(sendData)
  return <>

    <div className={'d-flex flex-start w-100 addProductSection__css'}>
      {isShowStoreRoom !== false ? <SelectProductStoreRoom
        type={storeRoomType === undefined ? 'sell' : storeRoomType}
        selectedStore={selectedStore}
      /> : <></>}
      {isLoading ? <span className={'pt-2'}> &#x25CF; </span> :
        <>

          {mode!=='buyReturn' &&
            <>
              <div className={'mx-2'}>
                <div>
                  <button
                    onClick={() => setMyData({
                      showBasedOn: 'nameBtn',
                      showPackageTypeList: false,
                      selectedBarcodeValue: ""
                    })}
                    className={`btn__switch  ${myData.showBasedOn === 'nameBtn' && 'btn__switch__selected'}`}
                  >
                    فله
                  </button>
                  <button
                    onClick={() => setMyData({
                      showBasedOn: 'barcodeBtn',
                      showPackageTypeList: false,
                      selectedBarcodeValue: ""
                    })
                    }
                    className={`btn__switch  ${myData.showBasedOn === 'barcodeBtn' && 'btn__switch__selected'}`}>
                    بسته
                  </button>

                </div>
              </div>
            </>
          }
          {myData.showBasedOn === 'barcodeBtn' ?
            <>
              <div style={{marginLeft: 10, width: 'max-content'}}>
                <div>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="جستجو"
                    name="search"
                    // onKeyUp={handlePressEnter}
                    list="factorPageProductList"
                    autoComplete="off"
                    // value={myData.selectedBarcodeValue}
                    value={myData.selectedBarcodeValue}
                    onChange={e => barcodeInputChangeHandler(e, setMyData)}
                    // id={"focusSearchData"}
                    autoFocus

                  />
                </div>
                <datalist id="factorPageProductList">
                  {myData.barcodeListToShow.map((ob, index) => <option key={index} value={ob.value + ''}/>)}
                </datalist>
              </div>

            </> :
            <>
              <div className={'d-flex'} style={{marginLeft: 10, width: 'max-content'}}>
                <Select

                  options={myData.allProductList}
                  // onChange={(e) => console.log(e)}
                  onChange={e => changeNameHandler(e, setMyData)}
                  // name='sample'
                  placeholder='بر اساس نام'
                  // defaultValue={2}
                  // disabled={true}
                  required={false}
                  className='reactSelectStyleInAddProduct'
                  listStyle={{
                    backgroundColor: '#fafafa',
                    border: '1px solid #ccc',
                  }}
                  // activeItemStyle={{ backgroundColor: '#e0e000' }}
                  // iconWidth='50'
                  // iconStyle={{
                  //   fontSize: '26px',
                  //   borderRadius: '0 5px 5px 0',
                  // }}
                  // purpose='search'
                  // onSearch={(e) => console.log(e)}
                  // onExactSearch={(e) => console.log(e)}
                />
                {myData.showPackageTypeList ? <>
                  <Select

                    options={myData.packageTypesList}
                    // onChange={(e) => console.log(e)}
                    onChange={e => changePackageTypeHandler(e, setMyData)}
                    // name='sample'
                    placeholder='انتخاب نوع بسته بندی'
                    // defaultValue={2}
                    // disabled={true}
                    required={false}
                    className='reactSelectStyleInAddProduct'
                    listStyle={{
                      backgroundColor: '#fafafa',
                      border: '1px solid #ccc',
                    }}
                    // activeItemStyle={{ backgroundColor: '#e0e000' }}
                    // iconWidth='50'
                    // iconStyle={{
                    //   fontSize: '26px',
                    //   borderRadius: '0 5px 5px 0',
                    // }}
                    // purpose='search'
                    // onSearch={(e) => console.log(e)}
                    // onExactSearch={(e) => console.log(e)}
                  />

                </> : <></>
                }


              </div>
            </>
          }
          <button

            style={{backgroundColor: '#5a507b', padding: 8, width: 'auto', borderRadius: 10}}
            // className="btn btnCustom btnSubmit border border-black bg-success"
            // className="btn btnCustom btnSubmit"
            onClick={e => addProductHandlerSadanShop(
              e, componentData, mode, setSendData, sendData, myData,setMyData
            )}
          >
            <img src={square} alt=""/>
          </button>
        </>
      }

    </div>


  </>

}
export default AddProductSectionSadan;
